<template>
  <div class="index-page page-main">
    <div class="search-box">
      <van-search
        v-model="keyword"
        @search="searchList"
        show-action
        placeholder="请输入搜索关键词"
      >
        <template #action>
          <van-button class="button" type="primary" @click="searchList"
            >搜索</van-button
          >
        </template>
      </van-search>
    </div>

    <div class="main">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="more"
      >
        <div
          class="list"
          v-for="item in dataList"
          :key="item.id"
          @click="toDetail(item)"
        >
          <div class="left">
            <div class="image-box">
              <img :src="item.titleImg" alt="" />
            </div>
          </div>

          <div class="right">
            <div class="title">{{ item.titleName }}</div>
            <div class="info">{{ item.introduction }}</div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import api from "@/api/api";

export default {
  props: {},
  data() {
    return {
      keyword: "",
      dataList: [],
      currentPage: 1,
      loading: true,
      finished: false,
    };
  },
  async created() {
    this.getList();
    // this.searchList();
  },
  methods: {
    toDetail(item) {
      this.$router.push(`/index?id=${item.id}`);
    },
    more() {
      this.currentPage += 1;
      this.getList();
    },
    async getList() {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.loading = true;
      this.finished = false;
      const classId = this.$route.query.classId;
      console.log(classId)
      const data = await api.getList({
        pageNum: this.currentPage,
        pageSize: 10,
        titleName: this.keyword,
        classId: classId,
      });
      this.$toast.clear();

      if (data.code === 200) {
        this.dataList = this.dataList.concat(data.rows);

        this.finished = data.rows.length !== 10;
        this.loading = false;
      }
    },
    searchList() {
      this.currentPage = 1;
      this.dataList = [];
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.index-page {
  background-color: #f9fbff;
  height: 100%;
  box-sizing: border-box;
  max-width: 7.5rem;
  margin: 0 auto;
  font-size: 0.36rem;

  .search-box {
    padding-right: 12px;
    background-color: #fff;
  }

  .main {
    height: calc(100% - 54px);
    overflow-y: auto;

    .list {
      padding: 0.16rem;
      background-color: #fff;
      border-bottom: 0.01rem solid #ccc;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;

      &:last-child {
        border-bottom: 0;
      }

      .image-box {
        width: 1.8rem;
        height: 1.8rem;
        overflow: hidden;
        border-radius: 0.16rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #eee;

        img {
          width: 100%;
        }
      }

      .right {
        margin-left: 0.16rem;
      }

      .title {
        font-size: 0.32rem;
        color: #000;
        font-weight: 600;
        line-height: 0.44rem;
        height: 0.44rem;
      }

      .info {
        color: #666;
        font-size: 0.28rem;
        margin-top: 0.2rem;
        height: 1.08rem;
        line-height: 0.36rem;
        width: 100%;
        word-break: break-all;
        word-wrap: break-word;
        display: -webkit-box;
        -webkit-line-clamp: 3; /* 显示行数 */
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  /deep/ .van-search__action {
    padding: 0;
    .button {
      height: 34px;
      display: block;
    }
  }
  /deep/ .van-search__action {
    margin-left: 0.24rem;
  }
}
</style>